import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { ButtonGroup as ButtonGroup$1 } from '@chakra-ui/react';
import { DesignSystem } from '@everfi/design-system';
var _excluded = ["colorScheme", "gap", "isAttached", "isDisabled", "isFullWidth", "isVertical", "justifyContent", "size", "variant"];

var ButtonGroup = function ButtonGroup(_ref) {
  var colorScheme = _ref.colorScheme,
      _ref$gap = _ref.gap,
      gap = _ref$gap === void 0 ? DesignSystem.Space.MD : _ref$gap,
      _ref$isAttached = _ref.isAttached,
      isAttached = _ref$isAttached === void 0 ? false : _ref$isAttached,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isFullWidth = _ref.isFullWidth,
      isFullWidth = _ref$isFullWidth === void 0 ? false : _ref$isFullWidth,
      _ref$isVertical = _ref.isVertical,
      isVertical = _ref$isVertical === void 0 ? false : _ref$isVertical,
      justifyContent = _ref.justifyContent,
      size = _ref.size,
      variant = _ref.variant,
      props = _objectWithoutProperties(_ref, _excluded);
  /**
   * DOM
   */


  return /*#__PURE__*/React.createElement(ButtonGroup$1, _extends({
    colorScheme: colorScheme,
    "data-object-type": "core-button-group",
    isAttached: isAttached,
    isDisabled: isDisabled,
    justifyContent: justifyContent,
    size: size,
    spacing: 0,
    variant: variant
  }, !isAttached && {
    gap: gap
  }, isFullWidth && {
    width: 'full'
  }, isVertical && {
    orientation: 'vertical'
  }), props.children);
};

ButtonGroup.displayName = "ButtonGroup";
export { ButtonGroup };